import { render, staticRenderFns } from "./AnimatedCheckmark.vue?vue&type=template&id=ef7f7524&scoped=true&"
var script = {}
import style0 from "./AnimatedCheckmark.vue?vue&type=style&index=0&id=ef7f7524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7f7524",
  null
  
)

export default component.exports